<template>
  <div id="kt_footer" class="footer d-flex flex-lg-column">
    <div class="container-xxl d-flex flex-column flex-md-row flex-stack">
      <div class="text-dark">
        <span class="text-gray-400 fw-semibold me-1">Сделано в</span>
        <a href="https://theeurasia.kz/" target="_blank" class="text-muted text-hover-primary fw-semibold me-2 fs-6">Евразия</a>
      </div>
      <div v-if="getVersion" class="text-dark">
        <span class="text-muted fs-7">
          Версия:
          <span  data-bs-toggle="modal" data-bs-target="#versionsModalInfo" class="text-primary cursor-pointer fw-bold me-2 fs-6">{{ getVersion[0].version.replace("Версия ", "") }}</span>
        </span>
      </div>
      <ul class="menu menu-gray-600 menu-hover-primary fw-semibold order-1">
        <li class="menu-item">
          <a href="https://theeurasia.kz/" target="_blank" class="menu-link px-2">Служба Тех. Поддержки</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "VFooter",
  computed: {
    getVersion() { return this.$store.getters.getVersions },
  },
}
</script>

<style scoped>

</style>